/**
 * App.tsx
 * =============================================================================
 * Root application component for Neuro-Audio Lab.
 *
 * @author Neuro-Audio Lab
 * @version 2.0.0 - Persistent Player Architecture
 */

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { MainLayout } from './components/layout/MainLayout';
import { Home } from './pages/Home';
import { Science } from './pages/Science';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-[#141414] text-white antialiased">
        <Routes>
          <Route element={<MainLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/science" element={<Science />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;